import { render } from "./ConfirmOTP.vue?vue&type=template&id=44554428&scoped=true&ts=true"
import script from "./ConfirmOTP.vue?vue&type=script&lang=ts"
export * from "./ConfirmOTP.vue?vue&type=script&lang=ts"

import "./ConfirmOTP.vue?vue&type=style&index=0&id=44554428&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44554428"]])

export default __exports__